import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { Router } from '@angular/router';
import { MonStaticSpriteComponent } from '../mon-static-sprite/mon-static-sprite.component';
import { DailyChallengeService } from '../../services/daily-challenge.service';
import { MobileScaleService } from '../../services/mobile-scale.service';
import { OverlayDismissDirective } from '../../directives/overlay-dismiss.directive';

@Component({
  selector: 'app-daily-challenge-card',
  imports: [NgTemplateOutlet, MonStaticSpriteComponent, OverlayDismissDirective],
  templateUrl: './daily-challenge-card.component.html',
  styleUrls: [
    './daily-challenge-card.component.css',
    './daily-challenge-card.component.mobile.css',
  ],
  host: { '(document:keydown.escape)': 'onEscapeKey()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DailyChallengeCardComponent {
  readonly daily = inject(DailyChallengeService);
  readonly mobile = inject(MobileScaleService);
  private readonly router = inject(Router);

  /** Mobile shows a one-line entry; the full card opens as a modal from it. */
  readonly showModal = signal(false);

  onEscapeKey() {
    if (this.showModal()) this.showModal.set(false);
  }

  async challenge() {
    this.showModal.set(false);
    await this.daily.startDailyChallenge();
  }

  openBoard() {
    this.showModal.set(false);
    this.router.navigate(['/leaderboard'], { queryParams: { mode: 'boss' } });
  }
}
